import classNames from "classnames"
import Spinner, { SPINNER_SIZES, SPINNER_THEMES } from '../icons/Spinner';

const SubmitButton = ({ className = "", submitText, onClick, loading = false, disabled }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className={classNames(className, "relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:opacity-75 disabled:cursor-not-allowed")}
      disabled={disabled}
    >
      {submitText}
      {loading && <Spinner className="ml-3" size={SPINNER_SIZES.SMALL} theme={SPINNER_THEMES.DARK} />}
    </button>
  )
}

export default SubmitButton
